module.exports = __webpack_public_path__ + "img/smartphone.95b50832.jpg";